import type { AllValues } from '@/utils/types/types.util';
import { PermissionKeyEnum } from './permission.types';
import { CorePermissions } from './permissions';

const getBrowserStorage = (): Storage | undefined => {
  try {
    return globalThis.window === undefined ? undefined : globalThis.window.localStorage;
  } catch (error) {
    console.warn('Browser storage is unavailable', error);
    return undefined;
  }
};

export function savePermissionsToStorage(
  permissionKey: PermissionKeyEnum,
  permissions: AllValues<typeof CorePermissions>[],
) {
  getBrowserStorage()?.setItem(permissionKey, JSON.stringify(permissions));
}

type CorePermissionValue = AllValues<typeof CorePermissions>;

export function loadCorePermissionsFromStorage(): CorePermissionValue[] {
  const storageValue = getBrowserStorage()?.getItem(PermissionKeyEnum.Core);
  if (!storageValue) {
    return [CorePermissions.Tiles.FullRead];
  }

  try {
    return JSON.parse(storageValue);
  } catch (error) {
    console.warn('Failed to parse core permissions from storage', error);
    return [];
  }
}
